import { Stack, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { AppRoutes } from "../../types/enums";
import { GradientButton } from "../ui";

export const NoCampaignsBlock = () => {
  return (
    <Stack
      direction="row"
      gap="16px"
      borderRadius="6px"
      bgcolor="#ECEEF099"
      padding="16px"
      alignItems="flex-start"
      border="1px solid #D9D9D9"
    >
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        flexGrow={1}
      >
        <Stack gap="4px">
          <Typography
            variant="subtitle1"
            color="custom.textDarkBlue"
            sx={{ fontWeight: 500 }}
          >
            No campaigns yet
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Enter product details, choose campaign criteria, and optionally
            upload accounts and contacts to create your campaign.
          </Typography>
        </Stack>
        <Link to={AppRoutes.CREATE_CAMPAIGN}>
          <GradientButton sx={{ textWrap: "nowrap" }}>
            Start new campaign
          </GradientButton>
        </Link>
      </Stack>
    </Stack>
  );
};
